import * as t from './actionTypes';

const initialState = { events: [], specialLoading: false, dailySpecials: [{title: '', content: ''}] };

const eventReducer = (state = initialState, action) => {
  switch (action.type) {
    // event load success
    case t.EVENT_LOAD_SUCCESS:
      // snapshot value
      let events = action.events;
      if (!events) {
        events = [];
      }
      // set up and return state
      state = Object.assign({}, state,
        { events: events }
       );
      return state;
    // special save
    case t.SPECIAL_SAVE:
      state = Object.assign({}, state, { dailySpecials: action.payload });
      return state;
    // special set loading
    case t.SPECIAL_SET_LOADING:
        return Object.assign({}, state, { specialLoading: true });
    // special unset loading
    case t.SPECIAL_UNSET_LOADING:
        return Object.assign({}, state, { specialLoading: false });
    // default
    default:
        return state;
  }
};

export default eventReducer;
